import {Component, Input, OnInit} from '@angular/core';
import {NgIf, NgOptimizedImage} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-template-contact',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgIf,
    TranslateModule
  ],
  templateUrl: './template-contact.component.html',
  styleUrl: './template-contact.component.scss'
})
export class TemplateContactComponent implements OnInit {

  @Input() public partner;
  @Input() public locale: string = 'en';

  public imgAltText: string = 'Illustration of the contact page';

  ngOnInit(): void {
    if (this.locale !== 'en') {
      this.imgAltText = 'Illustration de la page contact du partenaire';
    }
    if (typeof this.partner.contactInformations === 'string') {
      this.partner.contactInformations = JSON.parse(this.partner.contactInformations);
    }
    if (!this.partner.img || this.partner.img.trim().length === 0) {
      this.partner.img = window.location.protocol + '//' + window.location.host + '/assets/img/post_booking/' + this.locale + '-post_booking-contact_page.svg';
      this.partner.imgMobile = window.location.protocol + '//' + window.location.host + '/assets/img/post_booking/' + this.locale + '-mobile-post_booking-contact_page.svg';
    }
  }

  public setRedirection(): void {
    localStorage.setItem('redirect', this.partner.contactInformations.website);
  }

}
